export enum WorkflowActionColor {
  Green = 1,
  Orange,
  Default,
  Red,
}
